import type { FaireProductEntity } from "../../entity_types/product";

export const p_k2939favtu: FaireProductEntity = {
  token: "p_k2939favtu",
  type: "product",
  name: "Coffeetime Bunnies Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/2c9bffc993fc1e7ab3f8cf5c5d5459148a846463b024ca226a2e07b352a7d4ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48af7fc67e80a03c6e321a1d2712fb0899c39257607e06eaea1392f6a3e030a6.jpeg",
    "https://cdn.faire.com/fastly/a6860e504216e044b1bbdd013993faee6b16d8c9f027d72a7aee07e0a13d026e.jpeg",
    "https://cdn.faire.com/fastly/fc2511eb03d7539445e95f7618153ce430d4c73c96cb9f1588f4971ca29299fa.jpeg",
    "https://cdn.faire.com/fastly/f967ab02f62a96091ec4b4baf4c22984d09ec69faf831f63be76b22e1b603d87.jpeg",
    "https://cdn.faire.com/fastly/2cab4cca9c43f67568c5865a0af3e58d2032391ae307e698777c1a00c88e99f0.jpeg",
    "https://cdn.faire.com/fastly/131772c3256dd9c1a08c1de9b61f9c689c279311b5c2cc006715ad6ab0a64281.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Whimsical Collection featuring an all-over design displaying a charming scene of bunnies enjoying coffee and baked goods that is replicated from original hand illustrated artwork. Double-sided towel displays a coordinating plaid pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Coffeetime Bunnies kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A cute garden-themed kitchen accessory that easily adds personality to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:22.453Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
